'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';
import moment from 'moment';
import StatisticsStore from './Statistics';
import {
  TrafficModalColumns,
  StorageModalColumns,
  TrafficBtnGroup,
  StorageBtnGroup
} from '../../const/TableConst';

class StatisticsResourceStore {
  @observable trafficBtnGroup = TrafficBtnGroup;
  @observable storageBtnGroup = StorageBtnGroup;
  @observable storageModalColumns = StorageModalColumns;

  @action.bound
  loadTrafficModalData({ label, value }) {
    let param = buildUrl({
      start: moment()
        .startOf('month')
        .format('YYYYMMDD'),
      end: moment()
        .endOf('month')
        .format('YYYYMMDD'),
      traffic: value,
      not: value == 20480 ? 'true' : 'false',
      page_size: 100000,
      page_num: 1
    });
    StatisticsStore.statisticsModalStatus = true;
    StatisticsStore.modalLoading = true;
    StatisticsStore.modalTitle = label;
    fetch(
      `/api/statistics/device/traffic/detail${param}`,
      { method: 'GET' },
      json => {
        StatisticsStore.dataSource = [...json.content].map((item, index) => {
          item['key'] = index;
          item['detail'] = (item['detail'] / 1024).toFixed(2);
          return item;
        });
        StatisticsStore.columns = TrafficModalColumns;
        StatisticsStore.modalLoading = false;
      }
    );
  }

  @action.bound
  loadStorageModalData({ label, value }) {
    let param = buildUrl({
      start: moment()
        .startOf('month')
        .format('YYYYMMDD'),
      end: moment()
        .endOf('month')
        .format('YYYYMMDD'),
      storage: value,
      not: false,
      page_size: 1000000,
      page_num: 1
    });
    StatisticsStore.statisticsModalStatus = true;
    StatisticsStore.modalLoading = true;
    StatisticsStore.modalTitle = label;
    fetch(
      `/api/statistics/device/storage/detail${param}`,
      { method: 'GET' },
      json => {
        StatisticsStore.dataSource = [...json.content].map((item, index) => {
          item['key'] = index;
          item['detail'] = (item['detail'] * 100).toFixed(2);
          return item;
        });
        StatisticsStore.columns = StorageModalColumns;
        StatisticsStore.modalLoading = false;
      }
    );
  }
}
export default new StatisticsResourceStore();



// WEBPACK FOOTER //
// ./src/store/Statistics/StatisticsResource.js